import React, { useEffect, useRef, useState } from 'react';
import { Popover } from '@mui/material';
import { useDebounce } from 'use-debounce';
import { TextToolTip } from '../toolTip';
import { Images, PermissionsList, RolePermission } from 'utils';

export const EditableTableSelectRow = (
  {
    currentItem,
    list,
    firstListTitle,
    secondList,
    secondListTitle,
    handleBlur,
  }) => {
  const [showEditBtn, setShowEditBtn] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchDebounce] = useDebounce(searchInputValue, 1000);
  const wrapperRef = useRef(null);
  const contentRef = useRef(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;


  useEffect(() => {
    if (currentItem) {
      setSelectedItem(currentItem);
    }
  }, [currentItem]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target) &&
        !document.querySelector('.editable-table-custom-input-dropdown-paper')?.contains(e.target)
      ) {
        setShowEditBtn(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const toggleMenu = (event) => {
    event ? setAnchorEl(event?.currentTarget) : setAnchorEl(null);
    setSearchInputValue('')
  };

  const handleSelectItem = (item) => {
    setSelectedItem(item);
  };

  const handleSearch = (value) => {
    setSearchInputValue(value);
  };

  return (
    <div
      className='editable-table-input-row-wrapper'
      ref={wrapperRef}
    >
      <div
        className={`editable-table-input-row-content ${showEditBtn ? 'editable-table-input-row-content-edit' : ''}`}
        ref={contentRef}
        onClick={(e) => {
          if (showEditBtn) {
            e.stopPropagation();
          }
        }}
      >
        <TextToolTip
          classNameText='editable-table-row-text'
          text={selectedItem?.name}
          content={selectedItem?.name}
        />
        {!showEditBtn ?
          RolePermission([PermissionsList?.ALL_ACCESS?.code, PermissionsList?.EDIT_PAYABLE_PAYEE?.code]) &&  <button
            className='editable-table-input-row-edit-btn'
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setShowEditBtn(true);
            }}
          >
            <img src={Images.edit} alt='edit' />
          </button>
          :
          <button
            className='editable-table-select-row-arrow'
            style={{ transform: open ? 'rotate(180deg)' : '' }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              toggleMenu({ currentTarget: contentRef?.current });
            }}
          >
            <img src={Images.arrowDownSvg} alt='arrow' />
          </button>
        }
      </div>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={(e) => {
          e.stopPropagation();
          toggleMenu();
        }}
        className={'editable-table-custom-input-dropdown-paper'}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className='editable-table-search-input-wrapper'>
          <input
            type='search'
            onChange={(e) => handleSearch(e?.target?.value)}
            placeholder={'Search...'}
            value={searchInputValue}
          />
        </div>

        {(firstListTitle && !!list.filter((item) => searchDebounce ? item?.name?.toLowerCase()?.includes(searchDebounce?.toLowerCase()): item)?.length) &&
          <h1 className='editable-table-custom-input-dropdown-title'>
            {firstListTitle}
          </h1>
        }

        {!!list?.filter((item) => searchDebounce ? item?.name?.toLowerCase()?.includes(searchDebounce?.toLowerCase()): item)?.length &&
          <ul className='editable-table-custom-input-dropdown-item-block'>
            {list?.filter((item) => searchDebounce ? item?.name?.toLowerCase()?.includes(searchDebounce?.toLowerCase()): item)?.map((item) => (
              <li
                key={item?.id}
                className={`editable-table-custom-input-dropdown-item-block-item ${item?.id === selectedItem?.id ? 'dropdown-item-block-item-selected' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggleMenu();
                  handleSelectItem(item);
                  setShowEditBtn(false);

                  if (handleBlur) {
                    handleBlur(item);
                  }
                }}
              >
                <TextToolTip
                  classNameText='editable-table-custom-input-dropdown-item-text'
                  content={item?.name}
                  text={item?.name}
                />
              </li>
            ))}
          </ul>
        }

        {(secondListTitle && !!secondList?.filter((item) => searchDebounce ? item?.name?.toLowerCase()?.includes(searchDebounce?.toLowerCase()): item)?.length) &&
          <h1 className='editable-table-custom-input-dropdown-title'
              style={{ paddingTop: 10, marginTop: 10, borderTop: '1px solid #E6ECF3' }}>
            {secondListTitle}
          </h1>
        }

        {!!secondList?.filter((item) => searchDebounce ? item?.name?.toLowerCase()?.includes(searchDebounce?.toLowerCase()): item)?.length &&
          <ul className='editable-table-custom-input-dropdown-item-block'>
            {secondList?.filter((item) => searchDebounce ? item?.name?.toLowerCase()?.includes(searchDebounce?.toLowerCase()): item)?.map((item) => (
              <li
                key={item?.id}
                className={`editable-table-custom-input-dropdown-item-block-item ${item?.id === selectedItem?.id ? 'dropdown-item-block-item-selected' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggleMenu();
                  handleSelectItem(item);
                  setShowEditBtn(false);

                  if (handleBlur) {
                    handleBlur(item);
                  }
                }}
              >
                <TextToolTip
                  classNameText='editable-table-custom-input-dropdown-item-text'
                  content={item?.name}
                  text={item?.name}
                />
              </li>
            ))}
          </ul>
        }
      </Popover>
    </div>
  );
};

